import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';
import { MarketplaceBadge } from '../components/MarketplaceFilter';

const fmt = (v, d = 0) =>
  v != null ? Number(v).toLocaleString('ru-RU', { maximumFractionDigits: d }) : '—';

export default function MvpAvitoAds({ clientId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiClient
      .get('/mvp/avito-ads', { params: { client_id: clientId } })
      .then(({ data: d }) => { if (!cancelled) setData(d); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [clientId]);

  if (loading) return <p className="text-[var(--wb-text-muted)]">Загрузка Avito Ads…</p>;

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-bold flex items-center gap-2">
          <MarketplaceBadge marketplace="avito_ads" />
          Avito Реклама + Метрика
        </h2>
        <p className="text-sm text-[var(--wb-text-muted)] mt-1">
          Расход из API Avito Ads · цели с сайта по utm_content = ad_id
        </p>
      </div>

      <div className="wb-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[var(--wb-surface-muted)] text-left">
            <tr>
              <th className="p-3">Креатив</th>
              <th className="p-3">Кампания</th>
              <th className="p-3">ad_id</th>
              <th className="p-3">Клики</th>
              <th className="p-3">Расход</th>
              <th className="p-3">Цели (Метрика)</th>
              <th className="p-3">Ценность</th>
              <th className="p-3">CPA</th>
              <th className="p-3">ROI</th>
            </tr>
          </thead>
          <tbody>
            {(data?.items || []).map((row) => (
              <tr key={row.ad_id} className="border-t border-[var(--wb-border)] hover:bg-[var(--wb-surface-muted)]/50">
                <td className="p-3 font-medium">{row.title}</td>
                <td className="p-3 text-[var(--wb-text-muted)]">{row.campaign_name}</td>
                <td className="p-3 font-mono text-xs">{row.ad_id}</td>
                <td className="p-3">{fmt(row.clicks)}</td>
                <td className="p-3">{fmt(row.spend)} ₽</td>
                <td className="p-3">{fmt(row.goal_completions)}</td>
                <td className="p-3">{fmt(row.goal_value)} ₽</td>
                <td className="p-3">{row.cpa != null ? `${fmt(row.cpa)} ₽` : '—'}</td>
                <td className="p-3">
                  {row.roi_pct != null ? (
                    <span className={row.roi_pct >= 0 ? 'text-emerald-600' : 'text-red-600'}>
                      {fmt(row.roi_pct, 1)}%
                    </span>
                  ) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
